function getShippingAmount(customerLocation, subtotal) {
    // orders > 100 get free shipping, else 19.99
    if(subtotal > 100){
        return 0.00
    } else {
        return 19.99
    }

}

export default getShippingAmount; 